// new root page with client-side router
import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import DisplayApp from "src/pages/apps/display/app";
import DisplayConundrumsStep from "src/pages/apps/display/conundrumStep";
import DisplayNoApp from "src/pages/apps/display/noApp";
import RemoteApp from "src/pages/apps/remote/app";
import RemoteConundrumsStep from "src/pages/apps/remote/conundrumStep";
import RemoteConundrums from "src/pages/apps/remote/conundrums";
import RemoteIdea from "src/pages/apps/remote/idea";
import RemoteLaunchpad from "src/pages/apps/remote/launchpad";
import WhatIsDojoCast from "src/pages/apps/remote/whatIsDojocast";
import NpsSurvery from "src/pages/npsSurvey";
import BeyondToolkit from "src/pages/beyondToolkit";
import BeyondToolkitBedtimeStories from "src/pages/beyondToolkit/bedtimeStories";
import BeyondToolkitBrushTeeth from "src/pages/beyondToolkit/brushTeeth";
import BeyondToolkitMindfulness from "src/pages/beyondToolkit/mindfulness";
import BeyondToolkitMusic from "src/pages/beyondToolkit/music";
import BeyondToolkitReadAlongs from "src/pages/beyondToolkit/readAlongs";
import BeyondToolkitShakeSillies from "src/pages/beyondToolkit/shakeSillies";
import BeyondToolkitTableTopics from "src/pages/beyondToolkit/tableTopics";
import BeyondToolkitTimer from "src/pages/beyondToolkit/timer";
import BeyondToolkitWhoseTurn from "src/pages/beyondToolkit/whoseTurn";
import { setNavigateImpl } from "src/utils/reactRouterNavigate";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <RouterNavigateProvider />
      <Routes>
        <Route path="/apps/remote/:mountPoint/:classId" element={<RemoteLaunchpad />} />
        <Route path="/apps/remote/:mountPoint/:classId/conundrums" element={<RemoteConundrums />} />
        <Route
          path="/apps/remote/:mountPoint/:classId/conundrums/:conundrumName/:stepName"
          element={<RemoteConundrumsStep />}
        />
        <Route path="/apps/remote/:mountPoint/ideas/:ideaId" element={<RemoteIdea />} />
        <Route path="/apps/remote/:mountPoint/:classId/:app" element={<RemoteApp />} />

        <Route path="/apps/display" element={<DisplayNoApp />} />
        <Route path="/apps/display/conundrums/:conundrumName/:stepName" element={<DisplayConundrumsStep />} />
        <Route path="/apps/display/:app" element={<DisplayApp />} />

        <Route path="/apps/help/what-is-dojocast" element={<WhatIsDojoCast />} />
        <Route path="/beyondToolkit" element={<BeyondToolkit />} />
        <Route path="/beyondToolkit/bedtimeStories" element={<BeyondToolkitBedtimeStories />} />
        <Route path="/beyondToolkit/brushTeeth" element={<BeyondToolkitBrushTeeth />} />
        <Route path="/beyondToolkit/mindfulness" element={<BeyondToolkitMindfulness />} />
        <Route path="/beyondToolkit/music" element={<BeyondToolkitMusic />} />
        <Route path="/beyondToolkit/readAlongs" element={<BeyondToolkitReadAlongs />} />
        <Route path="/beyondToolkit/shakeSillies" element={<BeyondToolkitShakeSillies />} />
        <Route path="/beyondToolkit/tableTopics" element={<BeyondToolkitTableTopics />} />
        <Route path="/beyondToolkit/timer" element={<BeyondToolkitTimer />} />
        <Route path="/beyondToolkit/whoseTurn" element={<BeyondToolkitWhoseTurn />} />
        <Route path="/npsSurvey" element={<NpsSurvery />} />
      </Routes>
    </BrowserRouter>
  );
}

function RouterNavigateProvider() {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigateImpl(navigate);
  }, [navigate]);
  return null;
}
